import { getStorageValue } from "./storage";
import { getCurrentLangFromRedux, getDir } from "./styleChanges";

export function styleStart(className, count = 1, responsive, seperator = "-") {
  if (getDir(getCurrentLangFromRedux()) === "rtl") {
    return responsive
      ? className + "e" + seperator + responsive + seperator + count
      : className + "e" + seperator + count;
  } else {
    return responsive
      ? className + "s" + seperator + responsive + seperator + count
      : className + "s" + seperator + count;
  }
}

export function styleEnd(className, count = 1, responsive, seperator = "-") {
  if (getDir(getCurrentLangFromRedux()) === "rtl") {
    return responsive
      ? className + "s" + seperator + responsive + seperator + count
      : className + "s" + seperator + count;
  } else {
    return responsive
      ? className + "e" + seperator + responsive + seperator + count
      : className + "e" + seperator + count;
  }
}

export function customStyle(className) {
  if (getDir(getCurrentLangFromRedux()) === "rtl") {
    return className + "AR";
  } else {
    return className + "EN";
  }
}

export function contentStart(className, responsive, seperator = "-") {
  if (getDir(getCurrentLangFromRedux()) === "rtl") {
    return responsive
      ? className + seperator + responsive + seperator + "end"
      : className + seperator + "end";
  } else {
    return responsive
      ? className + seperator + responsive + seperator + "start"
      : className + seperator + "start";
  }
}

export function contentEnd(className, responsive, seperator = "-") {
  if (getDir(getCurrentLangFromRedux()) === "rtl") {
    return responsive
      ? className + seperator + responsive + seperator + "start"
      : className + seperator + "start";
  } else {
    return responsive
      ? className + seperator + responsive + seperator + "end"
      : className + seperator + "end";
  }
}

export const nativeStyleEnd = (styleName, value) => {
  if (getDir(getCurrentLangFromRedux()) === "rtl")
    return { [styleName + "Left"]: value };
  else return { [styleName + "Right"]: value };
};

export const positionStyle = (value) => {
  if (getDir(getCurrentLangFromRedux()) === "rtl") return { left: value };
  else return { right: value };
};
